exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".GroupsTable .table__container--panel{background-color:#f5f7f7;color:#757575;border:1px solid #bdc3c7;border-width:1px 1px 0;border-style:solid;border-color:#bdc3c7}.GroupsTable .table__container--panel p{font-size:12px}.GroupsTable .table__container--separator{border-right:1px solid hsla(204,8%,76%,.5);content:\" \";height:8px;margin-top:8px;position:relative;right:0;top:0}.GroupsTable .table__container--filter{margin:3px;border:1px solid hsla(204,8%,76%,.5);font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a0162cfc","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/table/users/GroupsTable.vue
// module id = 1952
// module chunks = 0